const complianceItems = [
  {
    title: "通关合规",
    desc: "简化申报 + 归并申报 + 回执留痕 + 单证归档",
    icon: "ri-lock-line",
  },
  {
    title: "税务合规",
    desc: "免征不退 + 无票出口 + 每笔可追溯",
    icon: "ri-money-cny-circle-line",
  },
  {
    title: "收汇合规",
    desc: "阳光收汇 + 结汇到账 + 资金证据链归集",
    icon: "ri-exchange-funds-line",
  },
];

export default function Compliance() {
  return (
    <section id="compliance" className="py-16 md:py-28 bg-background-100">
      <div className="max-w-[1380px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-[30px] md:text-[44px] font-heading font-extrabold tracking-[-0.02em] text-foreground-800 mb-4">
            合规与安全
          </h2>
          <p className="text-[15px] md:text-[18px] text-foreground-500">
            按风险域管理，阳光合规出海
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-8 lg:gap-9">
          {complianceItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-[22px] p-8 md:p-10 border border-background-200/80 shadow-[0_10px_24px_rgba(15,23,42,0.05)] hover:-translate-y-1 hover:shadow-[0_16px_32px_rgba(15,23,42,0.1)] transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-[18px] bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center mb-8 shadow-[0_8px_20px_rgba(20,184,166,0.18)]">
                <i className={`text-background-50 text-2xl ${item.icon}`} />
              </div>
              <h3 className="text-[20px] md:text-[24px] font-extrabold text-foreground-800 mb-4">
                {item.title}
              </h3>
              <p className="text-[14px] md:text-[16px] leading-8 text-foreground-500">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}